import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import {
	XEditButtonIcon,
	XTag,
	XThemeButton,
	XThemeContainer,
	XThemeFilterButton,
	XThemeFilterCards,
	XThemeFilterCircleButton,
	XThemeInputText,
	XThemeLogsTags,
	XThemeTable,
	XThemeTag,
} from '../../styles/GlobalThemeStyle';
import {
	Row,
	Col,
	Space,
	Popover,
	Tooltip,
	Button,
	Progress,
	Spin,
} from 'antd';
import Header from '../../components/Header/Header';
import HeaderFile from '../../components/Header/HeaderFile';
import {
	InfoCircleOutlined,
	LoadingOutlined,
	PlusCircleFilled,
} from '@ant-design/icons';
import {
	XThemeBulkDetailsCard,
	XThemeBulkDetailsNoCases,
	XThemeBulkDetailsRevenueImpact,
	XThemeBulkOverallProgress,
	XThemeBulkTags,
	XThemeCustomLoader,
	XThemeEmptyBatche,
	XThemeProgressLottie,
	XThemeRefreshBTN,
} from './BatchesStyle';
import { Link } from 'react-router-dom';
import {
	getBatchByIdApi,
	getBatchByIdReset,
} from '../../actions/getBatchByIdAction';
import {
	checkModulePermissions,
	toTitleCase,
	truncateString,
	urlPagination,
} from '../../utils/helper';
import bulkProgress from '../../json/bulk-progress-2.json';
import {
	XTheme2Button,
	XTheme2MainTitle,
	XTheme2Table,
} from '../../styles/GlobalThemeStyleCQ';
import { XTheme2InnerCard, XTheme2Para1 } from '../Dashboard/DashboardStyleCQ';
const twoColors = {
	'0%': '#169191',
	'100%': '#82C446',
};

// const formatNumber = (cost) => {
// 	if (cost === 0) {
// 		return '0';
// 	}
// 	const costFloat = parseFloat(cost);
// 	const suffixes = ['K', 'M', 'B', 'T'];

// 	let formattedCost = costFloat;

// 	let suffix = '';
// 	for (const s of suffixes) {
// 		if (formattedCost < 1000) {
// 			break;
// 		}
// 		formattedCost /= 1000.0;
// 		suffix = s;
// 	}

// 	return `${Math.round(formattedCost)}${suffix}`;
// };

const formatNumber = (cost) => {
	if (cost === 0) {
		return '0';
	}
	const suffixes = ['K', 'M', 'B', 'T'];
	let formattedCost = cost;
	let suffix = '';

	for (const s of suffixes) {
		if (formattedCost < 1000) {
			break;
		}
		formattedCost /= 1000;
		suffix = s;
	}

	return `${formattedCost}${suffix}`;
};

const BatchDetails = (props) => {
	const { getBatchById, getBatchByIdReset, getBatchByIdState } = props;
	const { id } = useParams();
	const [dataLoaded, setDataLoaded] = useState(true);
	const [tableLoading, setTableLoading] = useState(false);
	const [batchData, setBatchData] = useState(null);
	const [casesData, setCasesData] = useState([]);
	const [filters, setFilters] = useState({
		page: 1,
		limit: 10,
		search: '',
		status: '',
	});
	const columns = [
		{
			title: 'Case ID',
			dataIndex: 'case_id',
			width: 100,
			render: (case_id) => (
				<Link
					to={`${case_id[2]}/${case_id[0]}`}
					state={{
						from: `/batch-details/${id}`,
						batchId: id,
					}}
				>
					<div style={{ width: '100px' }}>{case_id[1]}</div>
				</Link>
			),
		},
		{
			title: 'Patient ID',
			dataIndex: 'mrn',
			width: 100,
			render: (mrnId) => (
				<Link
					to={`${mrnId[2]}/${mrnId[0]}`}
					state={{
						from: `/batch-details/${id}`,
						batchId: id,
					}}
				>
					<div style={{ width: '100px' }}>{mrnId[1]}</div>
				</Link>
			),
		},
		{
			title: 'Patient Name',
			dataIndex: 'patient_name',
			width: 200,
			render: (nameId) => (
				<Link
					to={`${nameId[2]}/${nameId[0]}`}
					state={{
						from: `/batch-details/${id}`,
						batchId: id,
					}}
				>
					<div
						style={{
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word',
						}}
					>
						{truncateString(nameId[1], 25)}
					</div>
				</Link>
			),
		},
		{
			title: 'Insurance Company',
			dataIndex: 'insurance_company',
			width: 250,
		},
		{
			title: 'Hospital',
			dataIndex: 'hospital',
			width: 200,
		},
		{
			title: 'State',
			dataIndex: 'state',
			width: 150,
		},
		{
			title: 'Allocated To',
			dataIndex: 'allocated_to',
			width: 150,
		},
		{
			title: 'Status',
			dataIndex: 'status',
			width: 200,
			render: (status) => (
				<XThemeBulkTags className={status[0]}>
					{status[0] === 'human_intervention'
						? toTitleCase('require_user_input')
						: toTitleCase(status[0])}
				</XThemeBulkTags>
			),
		},
		{
			title: 'Created On',
			dataIndex: 'createdAt',
			width: 150,
		},
	];

	// Add ref for interval
	const intervalRef = useRef(null);

	// Add refresh function
	const refreshData = (isManualRefresh = false) => {
		if (id) {
			if (isManualRefresh) {
				setTableLoading(true);
				// Reset interval on manual refresh
				if (intervalRef.current) {
					clearInterval(intervalRef.current);
					intervalRef.current = setInterval(
						() => refreshData(false),
						10000,
					);
				}
			}

			getBatchById({
				id,
				...filters,
			});
		}
	};

	// Setup auto-refresh interval
	useEffect(() => {
		refreshData(); // Initial call
		intervalRef.current = setInterval(() => refreshData(false), 10000);

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
	}, [id, filters]);

	// Handle API response
	useEffect(() => {
		if (getBatchByIdState.apiState === 'success') {
			setBatchData(getBatchByIdState.data);
			setDataLoaded(false);
			setTableLoading(false);

			// Stop interval if progress is 100%
			if (
				getBatchByIdState.data?.progress_percentage === 100 &&
				intervalRef.current
			) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}

			if (getBatchByIdState.data?.cases?.length > 0) {
				const updatedData = [];
				getBatchByIdState.data.cases.map((item) => {
					updatedData.push({
						key: item._id,
						status_filing: [
							item.filing_status,
							item.revenue_cycle_stage,
						],
						case_id: [
							item._id,
							item?.case_id || '-',
							'/case/filings',
						],
						mrn: [item._id, item?.mrn || '-', '/case/filings'],
						patient_name: [
							item._id,
							item?.patient_name || '-',
							'/case/filings',
						],
						insurance_company: item?.insurance?.name || '-',
						hospital: item?.hospitals?.name || '-',
						state: item?.state || '-',
						allocated_to: item?.allocated_to || '-',
						status: [
							item.batch_status == 'rejected'
								? 'not_covered'
								: item.batch_status,
						],
						createdAt: moment(item.createdAt).format('DD-MM-YYYY'),
					});
				});
				setCasesData(updatedData);
			} else {
				setCasesData([]);
			}

			getBatchByIdReset();
		}
	}, [getBatchByIdState]);

	// Modify the refresh button handler
	const handleRefreshClick = () => {
		refreshData(true);
	};

	const handleTableChange = (pagination, filters, sorter) => {
		setTableLoading(true);
		setFilters({
			...filters,
			page: pagination.current,
			limit: pagination.pageSize,
		});
	};

	const handleSearch = (value) => {
		setTableLoading(true);
		if (value === '') {
			setFilters({
				...filters,
				search: '',
				page: 1,
			});
		} else {
			setFilters({
				...filters,
				search: value,
				page: 1,
			});
		}
	};

	const handleStatusClick = (status) => {
		setTableLoading(true);
		setFilters({
			...filters,
			status: status,
			page: 1,
		});
	};

	const getStatusTitle = (status) => {
		switch (status) {
			case 'pending':
				return 'Pending Cases';
			case 'processing':
				return 'In Progress Cases';
			case 'human_intervention':
				return 'Cases Requiring User Input';
			case 'inconclusive':
				return 'Inconclusive Cases';
			case 'letter_prepared':
				return 'Letter Prepared Cases';
			case 'rejected':
				return 'Not Covered Cases';
			default:
				return 'All Cases';
		}
	};

	// Add handleClear function
	const handleClear = () => {
		setTableLoading(true);
		setFilters({
			page: 1,
			limit: 10,
			search: '',
			status: '',
		});
	};

	// Add helper function to check if filters are active
	const isFiltersActive = () => {
		return filters.search !== '' || filters.status !== '';
	};

	return (
		<>
			<Col lg={24} xl={24} xs={0} md={0}>
				<Header
					headerTag={
						batchData?.batch_details?.batch_name || 'Batch Details'
					}
				/>
			</Col>
			<Col lg={0} xl={0} xs={24} md={24}>
				<HeaderFile />
			</Col>
			<Spin spinning={dataLoaded}>
				<XThemeContainer fluid>
					<Row gutter={[15, 15]} className="align-items-center mb-4">
						<Col
							xs={24}
							sm={24}
							md={11}
							lg={11}
							xl={11}
							className="text-center text-md-start"
						>
							<XTheme2MainTitle className="mb-2">
								{batchData?.batch_details?.batch_name ||
									'Batch Details'}
							</XTheme2MainTitle>
							<XTheme2Para1>Work Load Summary</XTheme2Para1>
						</Col>
					</Row>
					{batchData && (
						<Row gutter={[15, 15]} className="mb-3">
							<Col xs={24} sm={24} md={24} lg={17} xl={19}>
								<XThemeBulkDetailsCard className="gradientBg">
									<Row
										gutter={[15, 15]}
										className="align-items-center mb-3"
									>
										<Col xs={24} sm={16} md={16} lg={18}>
											<h1>
												Total{' '}
												<span>
													{batchData?.batch_details
														?.total_cases || 0}{' '}
													Cases
												</span>
											</h1>
											{/* <h6>Batch Summary</h6> */}
										</Col>
										<Col
											xs={24}
											sm={8}
											md={8}
											lg={6}
											className="text-center text-sm-end mb-3 mb-sm-0"
										>
											{isFiltersActive() && (
												<XTheme2Button
													size="middle"
													className="h-100 noBackground"
													onClick={handleClear}
												>
													Clear
												</XTheme2Button>
											)}
										</Col>
									</Row>
									<Row gutter={[15, 15]}>
										<Col
											xs={12}
											sm={8}
											md={4}
											lg={4}
											xl={4}
										>
											<XThemeBulkDetailsNoCases
												className={`pending ${
													filters.status === 'pending'
														? 'active'
														: ''
												}`}
												onClick={() =>
													handleStatusClick('pending')
												}
												style={{ cursor: 'pointer' }}
											>
												<img
													className="img-fluid"
													src="/images/bulk-pending-icon.svg"
													alt=""
												/>
												<h1 className="mt-3">
													{batchData
														?.batch_status_counts
														?.pending || 0}
												</h1>
												<h6 className="mt-2">
													Pending
												</h6>
											</XThemeBulkDetailsNoCases>
										</Col>
										<Col
											xs={12}
											sm={8}
											md={4}
											lg={4}
											xl={4}
										>
											<XThemeBulkDetailsNoCases
												className={`inProgress ${
													filters.status ===
													'processing'
														? 'active'
														: ''
												}`}
												onClick={() =>
													handleStatusClick(
														'processing',
													)
												}
												style={{ cursor: 'pointer' }}
											>
												<Row gutter={[15, 15]}>
													<Col xs={12}>
														<img
															className="img-fluid"
															src="/images/bulk-inprogress-icon.svg"
															alt=""
														/>
													</Col>
												</Row>
												<h1 className="mt-3">
													{batchData
														?.batch_status_counts
														?.processing || 0}
												</h1>
												<h6 className="mt-2">
													In Progress
												</h6>
												<Row>
													<Col xs={24}></Col>
												</Row>
												{batchData?.batch_status_counts
													?.processing > 0 && (
													// <XThemeProgressLottie
													// 	animationData={
													// 		bulkProgress
													// 	}
													// 	loop={true}
													// />
													<XThemeCustomLoader className="loader1" />
												)}
											</XThemeBulkDetailsNoCases>
										</Col>
										<Col
											xs={12}
											sm={8}
											md={4}
											lg={4}
											xl={4}
										>
											<XThemeBulkDetailsNoCases
												className={`requireUserInput ${
													filters.status ===
													'human_intervention'
														? 'active'
														: ''
												}`}
												onClick={() =>
													handleStatusClick(
														'human_intervention',
													)
												}
												style={{ cursor: 'pointer' }}
											>
												<img
													className="img-fluid"
													src="/images/bulk-require-user-input-icon.svg"
													alt=""
												/>
												<h1 className="mt-3">
													{batchData
														?.batch_status_counts
														?.human_intervention ||
														0}
												</h1>
												<h6 className="mt-2">
													Require User Input
												</h6>
											</XThemeBulkDetailsNoCases>
										</Col>
										<Col
											xs={12}
											sm={8}
											md={4}
											lg={4}
											xl={4}
										>
											<XThemeBulkDetailsNoCases
												className={`inconclusive ${
													filters.status ===
													'inconclusive'
														? 'active'
														: ''
												}`}
												onClick={() =>
													handleStatusClick(
														'inconclusive',
													)
												}
												style={{ cursor: 'pointer' }}
											>
												<img
													className="img-fluid"
													src="/images/bulk-inconclusive-icon.svg"
													alt=""
												/>
												<h1 className="mt-3">
													{batchData
														?.batch_status_counts
														?.inconclusive || 0}
												</h1>
												<h6 className="mt-2">
													Inconclusive
												</h6>
											</XThemeBulkDetailsNoCases>
										</Col>
										<Col
											xs={12}
											sm={8}
											md={4}
											lg={4}
											xl={4}
										>
											<XThemeBulkDetailsNoCases
												className={`letterPrepared ${
													filters.status ===
													'letter_prepared'
														? 'active'
														: ''
												}`}
												onClick={() =>
													handleStatusClick(
														'letter_prepared',
													)
												}
												style={{ cursor: 'pointer' }}
											>
												<img
													className="img-fluid"
													src="/images/bulk-letter-prepared-icon.svg"
													alt=""
												/>
												<h1 className="mt-3">
													{batchData
														?.batch_status_counts
														?.letter_prepared || 0}
												</h1>
												<h6 className="mt-2">
													Letter Prepared
												</h6>
											</XThemeBulkDetailsNoCases>
										</Col>
										<Col
											xs={12}
											sm={8}
											md={4}
											lg={4}
											xl={4}
										>
											<XThemeBulkDetailsNoCases
												className={`rejected ${
													filters.status ===
													'rejected'
														? 'active'
														: ''
												}`}
												onClick={() =>
													handleStatusClick(
														'rejected',
													)
												}
												style={{ cursor: 'pointer' }}
											>
												<img
													className="img-fluid"
													src="/images/bulk-rejected-icon.svg"
													alt=""
												/>
												<h1 className="mt-3">
													{batchData
														?.batch_status_counts
														?.rejected || 0}
												</h1>
												<h6 className="mt-2">
													Not Covered
												</h6>
											</XThemeBulkDetailsNoCases>
										</Col>
									</Row>
								</XThemeBulkDetailsCard>
							</Col>
							<Col xs={24} sm={24} md={24} lg={7} xl={5}>
								<XThemeBulkDetailsCard className="progressBarBody text-center">
									<h4 className="mt-2">Overall Progress </h4>
									<XThemeBulkOverallProgress
										type="dashboard"
										percent={
											batchData?.progress_percentage || 0
										}
										status="active"
										strokeWidth={15}
										// strokeColor="#108ee9"
										strokeColor={twoColors}
										gapDegree={180}
										strokeLinecap="butt"
									/>
									{/* <XThemeRefreshBTN
										size="large"
										icon={
											<img
												className="img-fluid me-2"
												src="/images/bulk-refresh-icon.svg"
												alt=""
											/>
										}
										onClick={handleRefreshClick}
									>
										Refresh
									</XThemeRefreshBTN> */}
								</XThemeBulkDetailsCard>
							</Col>
						</Row>
					)}
					<XThemeFilterCards className="mb-3">
						<Row className="mb-3">
							<Col xs={24} sm={16} md={16} lg={18}>
								<h1 className="cardTitle">
									Revenue Impact{' '}
									<span className="info">Beta</span>
								</h1>
							</Col>
						</Row>
						<Row gutter={[15, 15]}>
							<Col xs={24} sm={24} md={12} lg={8}>
								<XThemeBulkDetailsRevenueImpact className="denialAmount">
									<Row
										gutter={[15, 15]}
										className="align-items-center"
									>
										<Col xs={4}>
											<img
												className="w-100"
												src="/images/bulk-denial-amount.svg"
												alt=""
											/>
										</Col>
										<Col xs={16}>
											<h6 className="mb-2">
												Denial Amount ($)
											</h6>
											<h1>
												$
												{formatNumber(
													batchData?.case_amounts
														?.denial_amount || 0,
												)}
											</h1>
										</Col>
										<div className="fixInfo">
											<Tooltip title="Total denied amount in this batch.">
												<InfoCircleOutlined />
											</Tooltip>
										</div>
									</Row>
								</XThemeBulkDetailsRevenueImpact>
							</Col>
							<Col xs={24} sm={24} md={12} lg={8}>
								<XThemeBulkDetailsRevenueImpact className="potentialRecovery">
									<Row
										gutter={[15, 15]}
										className="align-items-center"
									>
										<Col xs={4}>
											<img
												className="w-100"
												src="/images/bulk-potential-recovery.svg"
												alt=""
											/>
										</Col>
										<Col xs={16}>
											<h6 className="mb-2">
												Potential Recovery ($)
											</h6>
											<h1>
												$
												{formatNumber(
													batchData?.case_amounts
														?.potential_recovery ||
														0,
												)}
											</h1>
										</Col>
										<div className="fixInfo">
											<Tooltip title="Total potential recovery amount that can be claimed.">
												<InfoCircleOutlined />
											</Tooltip>
										</div>
									</Row>
									{batchData?.batch_status_counts
										?.processing > 0 && (
										<XThemeCustomLoader className="loader2" />
									)}
								</XThemeBulkDetailsRevenueImpact>
							</Col>
							<Col xs={24} sm={24} md={12} lg={8}>
								<XThemeBulkDetailsRevenueImpact className="writeOff">
									<Row
										gutter={[15, 15]}
										className="align-items-center"
									>
										<Col xs={4}>
											<img
												className="w-100"
												src="/images/bulk-write-off.svg"
												alt=""
											/>
										</Col>
										<Col xs={16}>
											<h6 className="mb-2">
												Write Off ($)
											</h6>
											<h1>
												$
												{formatNumber(
													batchData?.case_amounts
														?.write_off || 0,
												)}
											</h1>
										</Col>
										<div className="fixInfo">
											<Tooltip title="Total Amount that has been written off.">
												<InfoCircleOutlined />
											</Tooltip>
										</div>
									</Row>
									{batchData?.batch_status_counts
										?.processing > 0 && (
										<XThemeCustomLoader className="loader3" />
									)}
								</XThemeBulkDetailsRevenueImpact>
							</Col>
						</Row>
					</XThemeFilterCards>
					<XTheme2InnerCard
						className="mb-3 withBackground"
						bodyStyle={{ padding: '20px 0px' }}
					>
						<div className="smallTopBottomPadding mb-3 px-4">
							<Row
								gutter={(15, 15)}
								className="align-items-center"
							>
								<Col
									xs={24}
									sm={24}
									md={12}
									lg={12}
									className="mb-3 mb-md-0"
								>
									<h1
										className="cardTitle mb-0"
										style={{ fontSize: '18px' }}
									>
										{getStatusTitle(filters.status)}
									</h1>
								</Col>
								<Col
									xs={24}
									sm={16}
									md={12}
									lg={12}
									className="mb-3 mb-sm-0 text-end"
								>
									<Space>
										<XThemeInputText
											size="large"
											allowClear
											placeholder="Search for Cases"
											onChange={(e) =>
												handleSearch(e.target.value)
											}
										/>
										<XTheme2Button>Search</XTheme2Button>
									</Space>
								</Col>
							</Row>
						</div>
						<XTheme2Table
							loading={tableLoading}
							columns={columns}
							dataSource={casesData}
							scroll={{ x: 991 }}
							onChange={handleTableChange}
							pagination={{
								total: batchData?.pagination?.total || 0,
								current: filters.page,
								pageSize: filters.limit,
								showSizeChanger: true,
								// showTotal: (total, range) =>
								// 	`${range[0]}-${range[1]} of ${total} items`,
							}}
						/>
					</XTheme2InnerCard>
				</XThemeContainer>
			</Spin>
		</>
	);
};

const mapStateToProps = (state) => ({
	getBatchByIdState: state.getBatchById,
});

const mapDispatchToProps = (dispatch) => ({
	getBatchById: (data) => dispatch(getBatchByIdApi(data)),
	getBatchByIdReset: () => dispatch(getBatchByIdReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BatchDetails);
